import { IDmTrangThaiHoc } from "../../../model/respone/category/IDmTrangThaiHoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmTrangThaiHocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmTrangThaiHoc[],
  LOAD_ERRR: "",
};
export const eDmTrangThaiHocActionIds = generateActionTypeIds(
  eDmTrangThaiHocActionsObj,
  "TRANG_THAI_HOC"
);
export type IDmTrangThaiHocActionTypes = IGenericActionType<
  typeof eDmTrangThaiHocActionsObj,
  "TRANG_THAI_HOC"
>;
